// MainLayout.jsx
import { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

export default function MainLayout({ children, minimalLayout = false }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {!minimalLayout && <Header handleDrawerToggle={handleDrawerToggle} />}
      {!minimalLayout && (
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: minimalLayout ? "100%" : { sm: `calc(100% - 240px)` },
          height: "100vh",
          overflowY: "auto",
          p: 3,
        }}
      >
        {!minimalLayout && <Toolbar />}
        {children}
      </Box>
    </Box>
  );
}
